import { useMembersContext } from '@/contexts/membersContext';
import { ZoomTokenResponse } from '@/types/videoSessions';
import ajax from '@/utils/ajax';

export const zoomRepository = {
  async getZoomToken({
    host,
    meetingNumber,
    role = '0'
  }: {
    host: string;
    meetingNumber?: string;
    role?: string;
  }): Promise<ZoomTokenResponse> {
    const params = new URLSearchParams();
    if (meetingNumber) {
      params.append('meeting_number', meetingNumber);
    }
    params.append('role', role);

    const queryString = params.toString();
    const url = `${host}/api/zoom-token${queryString ? `?${queryString}` : ''}`;

    const response = await ajax.get({
      url,
      config: {
        withCredentials: true
      }
    });

    return response.data;
  }
};

const ZoomRepository = () => {
  const { host } = useMembersContext();

  return {
    async getZoomToken(meetingNumber?: string, role = '0'): Promise<ZoomTokenResponse> {
      return zoomRepository.getZoomToken({ host, meetingNumber, role });
    }
  };
};

export default ZoomRepository;
